<template>
    <div id="receiptModal" ref="addCustomerModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title select">Receipt: {{ receipt._id }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body" id="receipt_container">
            <vue3-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="false"
              :preview-modal="true"
              :manual-pagination="false"
              :paginate-elements-by-height="1400"
              :filename="`ReturnReceipt-${receipt._id}.pdf`"
              :pdf-quality="2"
              pdf-format="A4"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              :html-to-pdf-options="options"
              html
              ref="receipt_body"
            >
              <template v-slot:pdf-content>
                <div class="container" id="receipt_body">
                  <div class="row">
                    <div class="col text-center">
                      <img class="w-50" draggable="false" src='@/assets/logo.png'>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="my-1">
                      <p class="text-center fw-bold">Return Receipt for Invoice: {{ receipt.invoice }}</p>
                      <hr class="my-1">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-start m-0">Date</p>
                    </div>
                    <div class="col-6 py-0">
                      <p class="text-start m-0">{{ receipt.date }}</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-start m-0">Branch: {{ receipt.branch }}</p>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-start m-0">Customer</p>
                    </div>
                    <div class="col-6 py-0">
                      <p class="text-start m-0">{{ receipt.customerName }} {{ receipt.customerPhone }}</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-start m-0">User: {{ receipt.user }}</p>
                    </div>
                  </div>

                  <div v-if="receipt.car">

                    <div class="row">
                      <div class="col-2 py-0">
                        <p class="text-start m-0">Car</p>
                      </div>
                      <div class="col-6 py-0">
                        <p class="text-start m-0">{{ receipt.car.brand }} {{ receipt.car.plate.join(' ') }}</p>
                      </div>
                      <div class="col-4 py-0">
                        <p class="text-start m-0">Milage: {{ formatThousand(receipt.car.miles) }} Km</p>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="py-1">
                      <table class="table table-sm border-dark unselect align-middle">
                        <thead>
                          <tr class="table-secondary border-dark">
                            <th class="text-start w-55">Item</th>
                            <th class="text-center w-15">Price</th>
                            <th class="text-center w-15">Quantity</th>
                            <th class="text-center w-15">Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="x, i in receipt.items" :key="i" class="border-dark">
                            <td class="text-start w-55">
                              {{ x.name }}
                              <span v-if="x.prod_date" class='subtitle'>Production Date: {{ x.prod_date }}</span>
                              <span v-if="x.reason == 'cr'" class='subtitle'>Reason: Customer Request</span>
                              <span v-if="x.reason == 'doa'" class='subtitle'>Reason: Damage on Arrival</span>
                            </td>
                            <td class="text-center w-15">{{ x.price }}</td>
                            <td class="text-center w-15">{{ x.quantity }}</td>
                            <td class="text-center w-15">
                              <span v-bind:class="x.discount ? 'text-decoration-line-through' : ''">
                                {{ (x.price * x.quantity).toFixed(2) }}
                              </span>
                              <span v-if="x.discount" class="d-block">
                                {{ x.value.toFixed(2) }}
                              </span>
                            </td>
                          </tr>

                          <tr class="table-secondary fw-bold">
                            <td class="text-start w-50">Tax {{ receipt.tax }}%</td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(receipt.subtotal * (receipt.tax||0)/100) }} $</td>
                          </tr>
                          <tr class="table-secondary fw-bold">
                            <td class="text-start w-50">Total</td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(receipt.total) }} $</td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="pb-0">
                      <svg class="barcode w-50" ref="receiptBarcode"></svg>
                    </div>
                  </div>

                </div>
              </template>
            </vue3-html2pdf>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col text-center">
                  <button class="btn btn-success bi-printer-fill w-50" @click="printReceipt()">
                    &nbsp;
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Print</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
</template>
<!-- ******************************************************** -->
<script>
    import Vue3Html2pdf from 'vue3-html2pdf'
    const $ = require('jquery');
    var JsBarcode = require("jsbarcode");
    export default {
        // eslint-disable-next-line
        name: 'ReturnReceipt',
        components: {
            Vue3Html2pdf
        },
        data(){
          return {
            receipt:{
              _id: '',
              total: 0,
            },
            options:{
              filename: '',
              margin: 7,
              html2canvas: { 
                scale: 2, 
                letterRendering: false
              },
            }
          }
        },
        created(){
        },
        methods:{
          //**********************************************************
          async view(receipt_id){
            var ack = await this.$service.getReturnReceipt({ id: receipt_id });
            if(ack.state != 'OK'){
              this.$toast(ack.state);
            }
            else{
              this.receipt = ack.data;
              JsBarcode(this.$refs.receiptBarcode, this.receipt._id);
              $('#receiptModal').modal('show');
            }
          },
          //**********************************************************
          async printReceipt(){
            this.$refs.receipt_body.generatePdf();
              // var invoiceBody = $('#invoice_body')[0].innerHTML;
              // let scale = 5;
              // let width = 210 * scale, height = 297 * scale;
              // let left = (window.innerWidth - 210) / 2;
              // let top = (window.innerHeight - 297) / 2;
              // const printWindow = window.open('', '', `left=${left},top=${top},width=${width},height=${height},toolbar=0,scrollbars=0,status=0`);
              // let css = Array.from($('link[rel="stylesheet"], style')).reduce((acc, node)=>acc + node.outerHTML, '');
              // printWindow.document.write(`
              //     <head>${css}</head>
              //     <body>${invoiceBody}</body>
              // `);
              // printWindow.document.close();
              // printWindow.focus();

              // printWindow.print();
              // await new Promise((res)=>setTimeout(res, 500));
              // printWindow.close();
          }
        }
    }
</script>
<!-- ******************************************************** -->
<style scoped>
#receipt_body > p{
    margin: none !important;
}
</style>
  